window.addEventListener("scroll", () => {
    whenScroll()
})
whenScroll()

export function whenScroll() {
    if (window.scrollY >= window.innerHeight) {
        document.body.classList.add("vh")
    } else {
        document.body.classList.remove("vh")
    }
    if (window.scrollY == 0) {
        document.body.classList.add("top")
        document.body.classList.remove("notTop")
    } else {
        document.body.classList.remove("top")
        document.body.classList.add("notTop")
    }
    if (document.documentElement.scrollHeight - window.scrollY <= window.innerHeight + 1) {
        document.body.classList.add("last")
    } else {
        document.body.classList.remove("last")
    }
    if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - document.querySelector(".footer__main>svg").height.animVal.value) {
        document.body.classList.add("footer-100px")
    } else {
        document.body.classList.remove("footer-100px")
    }
}